/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Ledger_UnreadableInputs */

const fr_api_ledger_unreadable = /** @type {(inputs: Api_Ledger_UnreadableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fichier Excel de la retenue est illisible pour le moment. Réessayez.`)
};

const en_api_ledger_unreadable = /** @type {(inputs: Api_Ledger_UnreadableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The withholding Excel file cannot be read right now. Try again.`)
};

/**
* | output |
* | --- |
* | "The withholding Excel file cannot be read right now. Try again." |
*
* @param {Api_Ledger_UnreadableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_ledger_unreadable = /** @type {((inputs?: Api_Ledger_UnreadableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Ledger_UnreadableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_ledger_unreadable(inputs)
	return fr_api_ledger_unreadable(inputs)
});